import clsx from 'clsx';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  isReverse?: boolean;
};
export function ButtonGroup({className, isReverse, ...props}: Props): React.JSX.Element {
  return (
    <span
      {...props}
      className={clsx(
        'isolate inline-flex flex-col shadow-xs *:not-first:-mt-px *:first:rounded-t-md *:last:rounded-b-md sm:flex-row sm:*:not-first:mt-0 sm:*:not-first:-ml-px sm:*:first:rounded-l-md sm:*:first:rounded-tr-none sm:*:last:rounded-r-md sm:*:last:rounded-bl-none',
        className
      )}
    >
      {props.children}
    </span>
  );
}

ButtonGroup.displayName = 'ButtonGroup';
